import { render } from "./Matchs.vue?vue&type=template&id=c044c894&scoped=true"
import script from "./Matchs.vue?vue&type=script&lang=js"
export * from "./Matchs.vue?vue&type=script&lang=js"

import "./Matchs.vue?vue&type=style&index=0&id=c044c894&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c044c894"]])

export default __exports__